import { render, staticRenderFns } from "./CommentManagement.vue?vue&type=template&id=2c9207a6"
import script from "./CommentManagement.vue?vue&type=script&lang=js"
export * from "./CommentManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports